// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__3mk50","loadingSpinner":"styles_loadingSpinner__2Vm7Q"};